/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumchancenspirit2Inputs */

const de__field_datumchancenspirit2 = /** @type {(inputs: _Field_Datumchancenspirit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum CHANCENspirit`)
};

/**

* @param {_Field_Datumchancenspirit2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumchancenspirit2 = /** @type {((inputs?: _Field_Datumchancenspirit2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumchancenspirit2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumchancenspirit2(inputs)
});
export { _field_datumchancenspirit2 as "_field_datumChancenSpirit" }